export const STORAGE_KEY = 'password-setup-details';
export const STORAGE_UPDATE_EVENT_TYPE = 'session-password-setup-details-change';
